import { Vehicle } from "../models/Vehicle";

const filterAll = (vehicles: Vehicle[]) => {
  return vehicles;
};

export default filterAll;
